
/**
 * CONFIG
 */
export const DEFAULT_DS_QUY = [
  {
    msQuy: "A",
    tenQuy: "Hoằng Pháp",
    note: "GỬI VỀ CLB",
    tp: "A,B,C",
    private: false,
  },
  {
    msQuy: "B",
    tenQuy: "Cúng dường tứ sự",
    note: "GỬI VỀ CLB",
    tp: "A,B,C",
    private: false,
  },
  {
    msQuy: "C",
    tenQuy: "Tri ân",
    note: "GỬI VỀ CLB",
    tp: "A,B,C",
    private: false,
  },
  {
    msQuy: "D",
    tenQuy: "Phóng sinh",
    note: "GỬI VỀ CLB",
    tp: "A,B,C",
    private: false,
  },
  {
    msQuy: "E",
    tenQuy: "Từ Thiện an sinh xã hội",
    note: "GỬI VỀ CLB",
    tp: "A,B,C",
    private: false,
  },
  {
    msQuy: "PS1",
    tenQuy: "Ẩm thực BQT",
    note: "GỬI VỀ CLB",
    tp: "A,B,C",
    private: false,
  },
  {
    msQuy: "Other",
    tenQuy: "Khác",
    note: "GỬI VỀ CLB",
    tp: "",
    private: true,
  },
  {
    msQuy: "Z1",
    tenQuy: "Phí hàng tháng",
    note: "Chi phí định kỳ",
    tp: "A,B,C",
    private: false,
  },
  {
    msQuy: "Z2",
    tenQuy: "Phí hoạt động",
    note: "Chi phí phát sinh",
    tp: "A,B,C",
    private: false,
  },
  {
    msQuy: "Y1",
    tenQuy: "Cúng dường",
    note: "Cúng dường",
    tp: "A,B,C",
    private: false,
  },
];
